"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertAssetSchemaKeys = exports.upsertAssetSchema = exports.AssetDataRenderingConditions = void 0;
const zod_1 = require("zod");
const enums_1 = require("../../schema/enums");
const utils_1 = require("../../utils");
const lodash_1 = require("lodash");
const location_1 = require("../../schema/subschemas/location");
const propertyDetails_1 = require("../../schema/subschemas/propertyDetails");
const documents_1 = require("../../schema/subschemas/documents");
const descriptions_1 = require("../../schema/subschemas/descriptions");
const images_1 = require("../../schema/subschemas/images");
const revenue_pool_1 = require("../../revenue-pool/revenue-pool");
exports.AssetDataRenderingConditions = {
    'investmentDetails.appraisalFirm': (asset) => Boolean(asset.propertyDetails?.constructionStatus === enums_1.TConstructionStatus.stock),
    'rentalDetails.contractEndDate': (asset) => Boolean(asset.rentalDetails?.contractType === enums_1.TContractType.closed),
    'rentalDetails.contractStartDate': (asset) => Boolean(asset.rentalDetails?.contractType === enums_1.TContractType.closed),
    'investmentDetails.expertRating': (asset) => Boolean(asset.propertyDetails?.constructionStatus === enums_1.TConstructionStatus.stock),
    // 'rentalDetails.plannedFirstRentalIncomeDate': (asset) => Boolean(asset.propertyDetails?.constructionStatus === TConstructionStatus.stock), // Apparently should always be displayed, leaving this in if we change our minds again.
    'rentalDetails.occupancyRate': (asset) => Boolean(asset.propertyDetails?.constructionStatus === enums_1.TConstructionStatus.stock),
};
exports.upsertAssetSchema = zod_1.z.preprocess(utils_1.removeNullUndefined, zod_1.z
    .object({
    type: zod_1.z.enum(utils_1.availableAssetTypes),
    descriptions: descriptions_1.DescriptionValidationSchema.pick({
        title: true,
        rentalDetails: true,
        floorPlanDetails: true,
        powerplantPictureTitle: true,
        powerplantPictureDetails: true,
        moduleType: true,
        nominalPowerPerModule: true,
        propertyQuote: true,
        propertySellingPoints: true,
        propertyHighlight: true,
        propertyDetails: true,
        locationDetails: true,
        cityDetails: true,
        districtDetails: true,
        overview: true,
    })
        .extend({
        nomenclature: descriptions_1.NomenclatureSchema.pick({
            rentalIncomeTitle: true,
            rentalIncome: true,
            managementFee: true,
            liquidityReserve: true,
            total: true,
            expectedYieldDisclaimer: true,
        })
            .extend({
            documents: descriptions_1.DocumentsSchema.pick({
                rentalAgreement: true,
                expertProtocol: true,
                landRegister: true,
                energyCertificate: true,
                utilityReport: true,
                plantList: true,
            }),
        })
            .partial(),
    })
        .partial(),
    location: location_1.LocationValidationSchema.pick({
        address: true,
        door: true,
        postalCode: true,
        city: true,
        countryCode: true,
        floor: true,
        staircase: true,
        coordinates: true,
    }),
    propertyDetails: propertyDetails_1.PropertyDetailsValidationSchema.pick({
        buildingYear: true,
        constructionStatus: true,
        size: true,
        numberOfRooms: true,
        carbonEmission: true,
        energyEmission: true,
        buildingCondition: true,
        propertyType: true,
        heatingType: true,
        powerOutput: true,
        powerOutputPerAnno: true,
        constructionType: true,
        commissioningDate: true,
        lifespan: true,
        propertySecurity: true,
        powerplantType: true,
        highlights: true,
        expectedBuildingStartDate: true,
        storage: true,
        storageSize: true,
    })
        .extend({
        // different 'features' type for request
        features: zod_1.z.array(utils_1.mongoDBObjectIdSchema),
    })
        .partial(),
    documents: documents_1.DocumentsValidationSchema.pick({
        plantList: true,
        expertProtocol: true,
        landRegister: true,
        energyCertificate: true,
        utilityReport: true,
        rentalAgreement: true,
        additionalDocuments: true,
    }),
    images: images_1.ImagesValidationSchema.pick({
        powerplant: true,
        floorPlans: true,
        propertyPhotos: true,
        locationPhotos: true,
    }),
    // TODO: pick
    investmentDetails: zod_1.z
        .object({
        appraisalFirm: zod_1.z.string(),
        expertRating: zod_1.z.number(),
        minSubscriptionAmount: zod_1.z.number(),
        landRegisterMortgageStatus: utils_1.booleanField,
        landRegisterMortgageStatusText: zod_1.z.string(),
        landRegisterMortgageDescription: zod_1.z.string(),
    })
        .partial(),
    // TODO: pick
    rentalDetails: zod_1.z
        .object({
        payoutInterval: zod_1.z.nativeEnum(enums_1.TPayoutInterval),
        contractStartDate: zod_1.z.coerce.date().nullable().default(null),
        expectedRentalStartDate: zod_1.z.coerce.date().nullable().default(null),
        contractEndDate: zod_1.z.coerce.date().nullable().default(null),
        rentalIncome: zod_1.z.number(),
        propertyManagementFee: zod_1.z.number(),
        liquidityReserve: zod_1.z.number(),
        rentalSurplus: zod_1.z.number(),
        plannedFirstRentalIncomeDate: zod_1.z.coerce.date().nullable().default(null),
        monthlyDistributionDate: zod_1.z.number(),
        occupancyRate: zod_1.z.number(),
        contractType: zod_1.z.nativeEnum(enums_1.TContractType),
        managementFee: zod_1.z.number(),
        additionalManagementCosts: zod_1.z.array(zod_1.z.object({
            name: zod_1.z.string(),
            amount: zod_1.z.number(),
        })),
        revenuePool: zod_1.z.union([zod_1.z.string(), revenue_pool_1.RevenuePoolSchema]),
    })
        .partial(),
})
    .partial()
    .transform((data) => {
    for (const key of Object.keys(exports.AssetDataRenderingConditions)) {
        const renderCondition = exports.AssetDataRenderingConditions[key];
        if (renderCondition && !renderCondition(data)) {
            (0, lodash_1.unset)(data, key);
        }
    }
    return data;
}));
exports.upsertAssetSchemaKeys = (0, utils_1.getZodSchemaKeys)(exports.upsertAssetSchema);
//# sourceMappingURL=index.js.map